import { SET_EDIT_NEWS_DATA } from '../actions/newsActions';

const initialState = {
  news: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EDIT_NEWS_DATA:
      return action.news;
    default:
      return state;
  }
}
